import React, { Suspense } from 'react';
import LoadingScreen from '~/components/screens/LoadingScreen';
import { StyleProp, ViewStyle } from 'react-native';

const PieChartComponent = React.lazy(() => import(/* webpackChunkName: "pieChart" */ '~/modules/pieChart/PieChart'));

type Props = {
    widthAndHeight: number;
    series: number[];
    sliceColor: string[];
    coverFill?: string | null;
    coverRadius?: number;
    style?: StyleProp<ViewStyle>;
};
export default function PieChart({ widthAndHeight, series, sliceColor, coverFill, coverRadius, style }: Props) {
    return (
        <Suspense fallback={<LoadingScreen />}>
            <PieChartComponent
                widthAndHeight={widthAndHeight}
                series={series}
                sliceColor={sliceColor}
                coverFill={coverFill}
                coverRadius={coverRadius}
                style={style}
            />
        </Suspense>
    );
}
